import theme from "../../styles/theme";
import { isDark } from "./colors";

export const getDivisionColor = (divisionColors, divisionName) => {
  if (!divisionColors) return null;
  const key = Object.keys(divisionColors).find(
    (k) => k.toLowerCase() === divisionName?.toLowerCase()
  );
  const item = key ? divisionColors[key] : null;
  if (item && typeof item === "object") {
    return item.color;
  }
  return item;
};

// Pick a readable text color for a given badge background using contrast detection.
export const getDivisionTextColor = (backgroundColor) =>
  isDark(backgroundColor) ? theme.colors.white : theme.colors.darkLight;

// Resolve a division's priority/order. Returns 999 as a fallback.
export const getDivisionPriority = (divisionColors, divisionName) => {
  if (!divisionColors) return 999;
  const key = Object.keys(divisionColors).find(
    (k) => k.toLowerCase() === divisionName?.toLowerCase()
  );
  const item = key ? divisionColors[key] : null;
  if (item && typeof item === "object" && typeof item.priority === "number") {
    return item.priority;
  }
  return 999;
};
